export const pipelineParametersNoticeLink =
  'https://helpserver.labs.jb.gg/help/teamcity/pipelines/main/pipeline-settings.html#Parameters'
